// For local development - if you need to access the BlazeData API endpoints from localhost
// set DEV_MODE to true and provide your api keys below in AUTH.
// Also make sure you run your browser with CORS disabled, e.g. for macOS:
// open -n -a /Applications/Google\ Chrome.app/Contents/MacOS/Google\ Chrome \
//   --args --user-data-dir="/tmp/chrome_dev_test" --disable-web-security
// example: VITE_DEV_MODE=true VITE_BLAZESV_CRANE_API_KEY_ID=myApiKeyId \
//          VITE_BLAZESV_CRANE_API_SECRET_KEY=myApiSecretKey npm start

import { VITE_DEV_MODE, VITE_BLAZESV_CRANE_API_KEY_ID, VITE_BLAZESV_CRANE_API_SECRET_KEY } from 'env';

const DEV_MODE = VITE_DEV_MODE ?? false;

const AUTH = {
  username: VITE_BLAZESV_CRANE_API_KEY_ID,
  password: VITE_BLAZESV_CRANE_API_SECRET_KEY,
};

/** Returns basic auth credentials when VITE_DEV_MODE is set, otherwise undefined. */
export const getAuth = () => {
  if (DEV_MODE) {
    return AUTH;
  }
  return undefined;
};
